import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { List, X, Phone, ArrowRight } from "@phosphor-icons/react";
import { COMPANY } from "@/data/site";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/solar", label: "Solar" },
  { to: "/cctv", label: "CCTV" },
  { to: "/ev", label: "EV" },
  { to: "/projects", label: "Projects" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  return (
    <header className="sticky top-0 z-50 glass-header" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-16 lg:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="nav-logo">
          <img
            src={COMPANY.logo}
            alt="TamilBTC Technologies"
            className="h-11 lg:h-14 w-auto object-contain"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-link-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-3.5 py-2 text-[13px] font-medium transition-colors ${
                  isActive ? "text-slate-900" : "text-slate-600 hover:text-slate-900"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={`tel:${COMPANY.phone}`}
            className="flex items-center gap-2 text-[13px] font-semibold text-slate-700 hover:text-slate-900"
            data-testid="nav-call-link"
          >
            <Phone size={16} weight="bold" />
            {COMPANY.phoneDisplay}
          </a>
          <Link
            to="/contact"
            className="group inline-flex items-center gap-2 bg-slate-900 text-white px-4 py-2.5 text-[13px] font-semibold hover:bg-slate-700 transition-colors"
            data-testid="nav-cta-survey"
          >
            Free Site Survey
            <ArrowRight size={14} weight="bold" className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>

        <button
          className="lg:hidden p-2 text-slate-900"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} weight="bold" /> : <List size={24} weight="bold" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white" data-testid="mobile-menu">
          <div className="px-5 py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className={`py-2.5 text-sm font-medium ${
                  loc.pathname === n.to ? "text-slate-900" : "text-slate-600"
                }`}
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              >
                {n.label}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex items-center justify-center gap-2 bg-slate-900 text-white px-4 py-3 text-sm font-semibold"
              data-testid="mobile-nav-cta"
            >
              Free Site Survey <ArrowRight size={14} weight="bold" />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
